import { makeStyles } from '@material-ui/core';
var switchStyles = makeStyles({
    root: {
        width: '5.72vw',
        height: '3.8vw',
        padding: 0,
        margin: 0,
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(2.33vw) translateY(-0.1vw)',
            '@media (aspect-ratio: 4/3)': {
                transform: 'translateX(2.33vw) translateY(-0.17vw)',
            },
            '& + $track': {
                opacity: 1,
                backgroundColor: '#54AF48',
                border: 'none',
            },
        },
    },
    thumb: {
        width: '3.2vw',
        height: '3.2vw',
        transform: 'translateY(0.35vh)',
        backgroundColor: 'white',
    },
    track: {
        border: "1px solid #e5e5e5",
        borderRadius: '3.6vw',
        opacity: 1,
        width: '5.72vw',
        height: '3.55vw',
        backgroundColor: 'white',
        transition: "background-color 375ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    checked: {},
});
export default switchStyles;
